/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectActivityResourcePastEventsInnerAuthor } from './';
import {
    ProjectActivityResourcePastEventsInnerAuthorFromJSON,
    ProjectActivityResourcePastEventsInnerAuthorFromJSONTyped,
    ProjectActivityResourcePastEventsInnerAuthorToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectActivityResourcePastEventsInner
 */
export interface ProjectActivityResourcePastEventsInner {
    /**
     * 
     * @type {string}
     * @memberof ProjectActivityResourcePastEventsInner
     */
    eventType: ProjectActivityResourcePastEventsInnerEventTypeEnum;
    /**
     * 
     * @type {ProjectActivityResourcePastEventsInnerAuthor}
     * @memberof ProjectActivityResourcePastEventsInner
     */
    author: ProjectActivityResourcePastEventsInnerAuthor;
    /**
     * 
     * @type {Date}
     * @memberof ProjectActivityResourcePastEventsInner
     */
    eventDate: Date;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProjectActivityResourcePastEventsInner
     */
    extraData: { [key: string]: string; };
}


/**
 * @export
 */
export const ProjectActivityResourcePastEventsInnerEventTypeEnum = {
    ClientAppraisedFreelancer: 'CLIENT_APPRAISED_FREELANCER',
    ClientPurchaseOrderRemoved: 'CLIENT_PURCHASE_ORDER_REMOVED',
    ClientPurchaseOrderUpdated: 'CLIENT_PURCHASE_ORDER_UPDATED',
    ContractAccepted: 'CONTRACT_ACCEPTED',
    ContractCancelled: 'CONTRACT_CANCELLED',
    ContractProposed: 'CONTRACT_PROPOSED',
    ExpenseBatched: 'EXPENSE_BATCHED',
    ExpenseApproved: 'EXPENSE_APPROVED',
    ExpenseBlocked: 'EXPENSE_BLOCKED',
    ExpenseCancelled: 'EXPENSE_CANCELLED',
    ExpensePaid: 'EXPENSE_PAID',
    ExpenseSubmitted: 'EXPENSE_SUBMITTED',
    InvoiceEmailSent: 'INVOICE_EMAIL_SENT',
    InvoiceEmitted: 'INVOICE_EMITTED',
    InvoiceLateEmailSent: 'INVOICE_LATE_EMAIL_SENT',
    InvoiceLateEmailSentToAccountingDepartment: 'INVOICE_LATE_EMAIL_SENT_TO_ACCOUNTING_DEPARTMENT',
    InvoiceLateFormalNoticeEmailSent: 'INVOICE_LATE_FORMAL_NOTICE_EMAIL_SENT',
    InvoiceLateFormalNoticeReminderEmailSent: 'INVOICE_LATE_FORMAL_NOTICE_REMINDER_EMAIL_SENT',
    InvoiceLetterSent: 'INVOICE_LETTER_SENT',
    LotCompleted: 'LOT_COMPLETED',
    LotCompletedAutomatically: 'LOT_COMPLETED_AUTOMATICALLY',
    LotEstimated: 'LOT_ESTIMATED',
    LotEditedByAdmin: 'LOT_EDITED_BY_ADMIN',
    LotProformaEmitted: 'LOT_PROFORMA_EMITTED',
    LotToPrepay: 'LOT_TO_PREPAY',
    LotValidationDocumentEmitted: 'LOT_VALIDATION_DOCUMENT_EMITTED',
    ManagerUpdated: 'MANAGER_UPDATED',
    PaymentBySepaDirectDebitInitiated: 'PAYMENT_BY_SEPA_DIRECT_DEBIT_INITIATED',
    PaymentBySepaDirectDebitActivated: 'PAYMENT_BY_SEPA_DIRECT_DEBIT_ACTIVATED',
    PaymentBySepaDirectDebitDeactivated: 'PAYMENT_BY_SEPA_DIRECT_DEBIT_DEACTIVATED',
    PaymentByTransferInitiated: 'PAYMENT_BY_TRANSFER_INITIATED',
    PaymentLotTransactionPaid: 'PAYMENT_LOT_TRANSACTION_PAID',
    PaymentTransactionFinancing: 'PAYMENT_TRANSACTION_FINANCING',
    PaymentTransactionPaid: 'PAYMENT_TRANSACTION_PAID',
    PaymentTransactionProvisioned: 'PAYMENT_TRANSACTION_PROVISIONED',
    PaymentTransactionRefunded: 'PAYMENT_TRANSACTION_REFUNDED',
    PaymentByCardRefunded: 'PAYMENT_BY_CARD_REFUNDED',
    PrepaymentLateEmailSent: 'PREPAYMENT_LATE_EMAIL_SENT',
    ProjectCancelled: 'PROJECT_CANCELLED',
    ProjectClosed: 'PROJECT_CLOSED',
    ProjectCompleted: 'PROJECT_COMPLETED',
    ProjectCompletedAutomatically: 'PROJECT_COMPLETED_AUTOMATICALLY',
    ProjectCompletionRequested: 'PROJECT_COMPLETION_REQUESTED',
    ProjectTimeAndMaterialCompleted: 'PROJECT_TIME_AND_MATERIAL_COMPLETED',
    QuoteAccepted: 'QUOTE_ACCEPTED',
    QuoteAmended: 'QUOTE_AMENDED',
    QuoteCreated: 'QUOTE_CREATED',
    RenewalInitiated: 'RENEWAL_INITIATED',
    RenewalAcceptedByFreelancer: 'RENEWAL_ACCEPTED_BY_FREELANCER',
    RenewalRefusedByFreelancer: 'RENEWAL_REFUSED_BY_FREELANCER',
    RenewalRefusedByClient: 'RENEWAL_REFUSED_BY_CLIENT',
    RenewalApproved: 'RENEWAL_APPROVED'
} as const;
export type ProjectActivityResourcePastEventsInnerEventTypeEnum = typeof ProjectActivityResourcePastEventsInnerEventTypeEnum[keyof typeof ProjectActivityResourcePastEventsInnerEventTypeEnum];


/**
 * Check if a given object implements the ProjectActivityResourcePastEventsInner interface.
 */
export function instanceOfProjectActivityResourcePastEventsInner(value: object): value is ProjectActivityResourcePastEventsInner {
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('author' in value) || value['author'] === undefined) return false;
    if (!('eventDate' in value) || value['eventDate'] === undefined) return false;
    if (!('extraData' in value) || value['extraData'] === undefined) return false;
    return true;
}

export function ProjectActivityResourcePastEventsInnerFromJSON(json: any): ProjectActivityResourcePastEventsInner {
    return ProjectActivityResourcePastEventsInnerFromJSONTyped(json, false);
}

export function ProjectActivityResourcePastEventsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectActivityResourcePastEventsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'eventType': json['eventType'],
        'author': ProjectActivityResourcePastEventsInnerAuthorFromJSON(json['author']),
        'eventDate': (new Date(json['eventDate'])),
        'extraData': json['extraData'],
    };
}

export function ProjectActivityResourcePastEventsInnerToJSON(value?: ProjectActivityResourcePastEventsInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eventType': value['eventType'],
        'author': ProjectActivityResourcePastEventsInnerAuthorToJSON(value['author']),
        'eventDate': ((value['eventDate']).toISOString()),
        'extraData': value['extraData'],
    };
}

